import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiDownload, FiEye, FiPackage } = FiIcons;

const LandingPage = () => {
  const fadeInUp = {
    initial: { opacity: 0, y: 30 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6 }
  };

  const staggerContainer = {
    animate: {
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const handleExecutiveSummaryDownload = () => {
    const url = 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1753220766062-ExecutiveSummary2025-video.dog%20%281%29.pdf';
    const link = document.createElement('a');
    link.href = url;
    link.download = 'The-Friendship-Pod-Affair-Executive-Summary.pdf';
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="min-h-screen bg-[#2a201d] text-[#ECDBBB] font-['Dosis']">
      <motion.div 
        className="container mx-auto px-6 py-12 max-w-4xl"
        variants={staggerContainer}
        initial="initial"
        animate="animate"
      >
        {/* Main Header */}
        <motion.header 
          className="text-center mb-16"
          variants={fadeInUp}
        >
          <h1 className="text-5xl md:text-7xl font-['Dancing_Script'] mb-4 text-[#ECDBBB] leading-tight">
            The Friendship Pod Affair
          </h1>
          <p className="text-xl md:text-2xl text-[#ECDBBB] opacity-90 max-w-2xl mx-auto">
            An outrageous story about enemies becoming friends.
          </p>
        </motion.header>

        {/* The Story Section */}
        <motion.section 
          className="mb-16"
          variants={fadeInUp}
        >
          <h2 className="text-3xl md:text-4xl font-['Dancing_Script'] text-center mb-8 text-[#ECDBBB]">
            The Story
          </h2>
          <p className="text-lg md:text-xl leading-relaxed text-center max-w-3xl mx-auto opacity-90">
            A young Israeli peace worker, who lost her baby in a horrific terrorist attack, embarks on a perilous quest to confront the bomber. Along the way, she discovers a hidden truth that challenges her beliefs and offers her a chance to heal the hate that killed her daughter and bring a new possibility to the world.
          </p>
        </motion.section>

        {/* Investment Opportunity Section */}
        <motion.section 
          className="mb-16"
          variants={fadeInUp}
        >
          <h2 className="text-3xl md:text-4xl font-['Dancing_Script'] text-center mb-8 text-[#ECDBBB]">
            An Investment in Hope
          </h2>
          <p className="text-lg md:text-xl leading-relaxed text-center max-w-3xl mx-auto mb-8 opacity-90">
            In a time of global division, 'The Friendship Pod Affair' emerges as a cinematic force for unity and inspiration. We are seeking partners to help bring this powerful and timely story to a worldwide audience. This is more than a film; it's a movement.
          </p>
          
          <div className="border-2 border-[#624B43] rounded-lg p-8 max-w-lg mx-auto text-center bg-[#2a201d] bg-opacity-50">
            <p className="text-2xl md:text-3xl font-bold mb-2 text-[#ECDBBB]">
              Seeking $25 Million USD for Full Production
            </p>
            <p className="text-lg opacity-80">
              (Accepting five $5 million investments or one at $25 million)
            </p>
          </div>
        </motion.section>

        {/* Executive Summary Download Section */}
        <motion.section 
          className="mb-16"
          variants={fadeInUp}
        >
          <h2 className="text-3xl md:text-4xl font-['Dancing_Script'] text-center mb-8 text-[#ECDBBB]">
            Explore the Vision
          </h2>
          <p className="text-lg md:text-xl leading-relaxed text-center max-w-3xl mx-auto mb-8 opacity-90">
            Our executive summary provides a detailed look at the film's purpose, marketing strategy, financial projections, and the experienced team dedicated to its success.
          </p>
          
          <div className="text-center">
            <motion.button 
              onClick={handleExecutiveSummaryDownload}
              className="bg-[#5C201F] hover:bg-[#7a2b29] text-[#ECDBBB] px-8 py-4 rounded-lg text-lg font-semibold transition-all duration-300 inline-flex items-center gap-3 shadow-lg hover:shadow-xl transform hover:-translate-y-1 cursor-pointer"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <SafeIcon icon={FiDownload} className="text-xl" />
              Download Executive Summary (PDF)
            </motion.button>
          </div>
        </motion.section>

        {/* Section Divider */}
        <motion.div 
          className="border-t border-[#624B43] my-16 max-w-2xl mx-auto"
          variants={fadeInUp}
        />

        {/* Footer */}
        <motion.footer 
          className="text-center"
          variants={fadeInUp}
        >
          <p className="text-lg mb-6 opacity-80">
            For more information, please review our other materials:
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <motion.a 
              href="https://www.reneemollanmastersma.com/the-movie-the-friendship-pod-affair"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#ECDBBB] hover:text-white transition-colors duration-300 inline-flex items-center gap-2 text-lg underline decoration-2 underline-offset-4 hover:decoration-white"
              whileHover={{ scale: 1.05 }}
            >
              <SafeIcon icon={FiEye} className="text-xl" />
              Watch Sneak Peek
            </motion.a>
            <motion.a 
              href="https://www.youtube.com/watch?v=2dDvSJ72l9c"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#E6B06C] hover:text-[#F0C184] transition-colors duration-300 inline-flex items-center gap-2 text-lg underline decoration-2 underline-offset-4 hover:decoration-[#F0C184]"
              whileHover={{ scale: 1.05 }}
            >
              <SafeIcon icon={FiPackage} className="text-xl" />
              How Film Financing Works
            </motion.a>
          </div>
        </motion.footer>
      </motion.div>
    </div>
  );
};

export default LandingPage;